import React from 'react';
import PageHeader from '../components/PageHeader';
import About from '../components/About';
import Stats from '../components/Stats';
import ClientGroups from '../components/ClientGroups';
import Process from '../components/Process';
import Team from '../components/Team';
import CtaBand from '../components/CtaBand';
import usePageMeta from '../utils/usePageMeta';

const AboutPage = () => {
  usePageMeta('About Fedigma: Digital Partner for Educational Institutes', 'Fedigma, by Fedigma Forge Pvt Ltd, is the Fusion of Digital Management for education: websites, apps, ERP, marketing, content and more for institutes.');

  return (
    <>
      <PageHeader
        eyebrow="About us"
        title="Your digital partner for education."
        subtitle="Fedigma is the Fusion of Digital Management for schools, colleges, kindergartens, libraries and private institutes."
      />
      <About />
      <Stats />
      <ClientGroups alt />
      <Process alt={false} />
      <Team />
      <CtaBand />
    </>
  );
};

export default AboutPage;
